import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationBarComponent } from './components/molecules/navigation-bar/navigation-bar.component';
import { AuthenticationFeatureService } from './features/authentication-feature/authentication-feature.service';
import { EmployeeFeatureService } from './features/employee-feature/employee-feature.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, filter, takeUntil } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';
import { MsalBroadcastService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NavigationBarComponent, MatProgressSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit, OnDestroy {
  public authFeature = inject(AuthenticationFeatureService);
  public employeeFeature = inject(EmployeeFeatureService);
  private broadcastService = inject(MsalBroadcastService);

  isLoadingEmployee = this.employeeFeature.isLoadingEmployee;

  private readonly destroying$ = new Subject<void>();

  ngOnInit(): void {
    this.authFeature.handleRedirectObservable().pipe(takeUntil(this.destroying$)).subscribe();

    this.broadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        takeUntil(this.destroying$),
      )
      .subscribe(() => {
        this.authFeature.checkAndSetActiveAccount();

        if (this.authFeature.isAuthenticated() && !this.employeeFeature.isEmployeeValidated()) {
          this.employeeFeature.validateEmployeeAccount().subscribe();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroying$.next();
    this.destroying$.complete();
  }
}
